import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Jocker } from '../../lottoloca-commom/lottery-modex';



@Component({
  selector: 'jocker-list',
  templateUrl: './jocker-list.component.html',
  styleUrls: ['./jocker-list.component.css'],
  providers: [

    { provide: MatFormFieldControl, useExisting: JockerListComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class JockerListComponent implements MatFormFieldControl<Jocker[]>, ControlValueAccessor {

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'jocker-list';
  id = `jocker-list-${JockerListComponent.nextId++}`;
  describedBy = '';


  private onChange: (value: Jocker[]) => void;

  public changeDate() {

    this.onChange(this.value);
  }

  writeValue(obj: Jocker[]): void {
    this.value = obj;
  }
  registerOnChange(onChange: (value: Jocker[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: Jocker): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): Jocker[] | null {

    const { value: { textValue } } = this.parts

    // let strDate:string = textValue;

    let texts = textValue.split("\n");

    let anys: Array<Jocker> = new Array();

    texts.forEach(x => {
      if(x!=null)
      {

        let split = x.split(';');

        let key = split[0];

        let name = split[1];

        let values = [];

        for(let  i = 2; i< split.length; i++ )
          {
            values.push(split[i]);
          }

          anys.push({key,name,values });

      }
     
    });




    return anys;

  }

  set value(value: Jocker[] | null) {
console.log(value);

    let text: string = '';
    if (value != null) {
      value.forEach(x => {
        if (x != null ) {
          text += x.key +";"+ x.name;

          if(x.values!=null)
          {
            x.values.forEach(element => {
              text += ";"+ element;
            });
          }
          text += '\n';
        }
      });


      this.parts.get("textValue").setValue(text.trim());

    }
    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl, fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'textarea') {
      this.elRef.nativeElement.querySelector('textarea')!.focus();
    }
  }
}
